import { endpoints } from '../../../.conf/resources';
import type {
  ContentServiceResult,
  FetchTeaserServiceConfig,
} from '../../helpers/utils/interfaces';
const baseUrl = endpoints.contentServiceApi;

class ContentServiceController {
  public data: ContentServiceResult;
  private fetchDataConfig: FetchTeaserServiceConfig;

  private async loadData() {
    return this.data ? this.data : await this.fetchData();
  }

  private async fetchData() {
    const apiUrl = await this.buildApiUrl();
    try {
      const dataResponse = await fetch(apiUrl);
      if (!dataResponse.ok) {
        throw new Error(dataResponse.statusText);
      }
      return await dataResponse.json();
    } catch (err) {
      return Promise.reject(err);
    }
  }

  private async buildApiUrl() {
    const teaserQuery = await this.buildTeaserQuery();
    return `${baseUrl}${teaserQuery}`;
  }

  private async buildTeaserQuery() {
    const {
      locale,
      companyCode,
      responsePage,
      responseTeaserCount,
      tag,
      rubric,
      mediaType,
      template,
    } = this.fetchDataConfig;
    if (responsePage && responseTeaserCount) {
      let url = `?locale=${locale}&companyCode=${companyCode}&rows=${responseTeaserCount}&page=${responsePage}`;
      url += this.getParamQuery('tag', tag);
      url += this.getParamQuery('rubric', rubric);
      url += this.getParamQuery('mediaType', mediaType);
      url += this.getParamQuery('template', template);
      url += this.getParamQuery('sort', 'lscore');
      return url;
    }
  }

  private getParamQuery(filterType: string, value: string): string {
    if (value) {
      return `&${filterType}=${value
        .replaceAll(' ', '+')
        .replaceAll('&', '%26')}`;
    }
    return '';
  }

  async getDataFromService(fetchConfig: FetchTeaserServiceConfig) {
    this.fetchDataConfig = fetchConfig;
    return await this.loadData();
  }
}

export const ContentTeaserData = new ContentServiceController();

export const defaultFetchConfig = {
  mediaType: ['IMAGE', 'VIDEO', 'YOUTUBE'].join(';'),
  template: [
    'pt_anleitung',
    'pt_standardseite',
    'pt_gabelseite',
    'pt_landingpage',
  ].join(';'),
};
